import { BuilderConfig } from '@/types/builder';

import { withChildren } from '@builder.io/react';
import RoomstayBlogSemTheme, { RoomstayBlogSemThemeProps } from './roomstay-blog-sem-theme';

export const RoomstayBlogProductThemeBuilderConfig = {
    name: 'Sem Theme',
    inputs: [
        {
            name: 'autoPadding',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'backgroundColor',
            type: 'color',
        },
    ],
};

const builderConfig: BuilderConfig<RoomstayBlogSemThemeProps> = {
    component: withChildren(RoomstayBlogSemTheme),
    config: RoomstayBlogProductThemeBuilderConfig,
};

export default builderConfig;
